import { forwardRef, useState } from 'react'
import './Button.scss'

export const ButtonWrapper = forwardRef(function ButtonWrapper({ onClick, light, round, small, smallOnMobile, disabled, width, fullWidth, className, type = 'button', style, children }, ref) {
  const [executing, setExecuting] = useState(false)

  const executeAction = (...args) => {
    if(onClick) {
      setExecuting(true)
      const result = onClick(...args)
      if(typeof result?.then === 'function') {
        Promise.resolve(result).finally(() => setExecuting(false))
      } else {
        setExecuting(false)
      }
    }
  }

  return (
    <button
      onClick={executeAction}
      className={`${(disabled || executing) ? '' : light ? 'light' : 'dark'}${round ? ' round' : ''}${small ? ' small' : ''}${smallOnMobile ? ' small-on-mobile' : ''}${className ? ` ${className}` : ''}`}
      disabled={disabled || executing}
      type={type}
      style={{ width: fullWidth ? "100%" : width, ...style }}
      ref={ref}
    >
      {children}
    </button>
  )
})